import { library } from '@fortawesome/fontawesome-svg-core'
import FontAwesome from '@fortawesome/fontawesome-pro/js/all'
import { faGoogle, faWindows } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  install (Vue) {
    library.add(FontAwesome)
    library.add(faGoogle)
    library.add(faWindows)

    Vue.component('FontAwesomeIcon', FontAwesomeIcon)
  }
}
